import { signInWithCustomToken } from "firebase/auth";

async function singInWithCustom(auth, token) {
  const authResp = await signInWithCustomToken(auth, token);
  return authResp;
}

export default singInWithCustom;
